import { Dialog } from "@material-ui/core";
import { useMemo, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import ABTestingFeatureTableCell from "../../Components/Table/ABTestingFeatureTableCell";
import SortableTable from "../../Components/Table/SortableTable";
import { TableColumnTypes } from "../../Enums/TableColumnTypes";
import { useGetClientABTestsQuery } from "../../Queries/ABTestQueries";
import { useAllClientsQuery } from "../../Queries/ClientManagementQueries";
import { IFeatureDto } from "../../Types/ABTests";
import { ITableColumn } from "../../Types/TableColumn";
import ABTestMetricsModal from "./ABTestMetricsModal";

const columns: ITableColumn[] = [
  { label: "Application", propName: "appName", type: TableColumnTypes.Text },
  { label: "Feature", propName: "name", type: TableColumnTypes.Text },
  { label: "Distribution Type", propName: "distribution", type: TableColumnTypes.Text },
  { label: "Key", propName: "key", type: TableColumnTypes.Text },
  { label: "View Metrics", propName: "", type: TableColumnTypes.Actions },
];

export default function ABTestClientDetailsPage() {
  const { clientId } = useParams<{ clientId: string }>();
  const { data, isLoading } = useGetClientABTestsQuery(clientId);
  const history = useHistory();
  const [selectedFeature, setSelectedFeature] = useState<{ name: string; key: string } | null>(null);
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const { data: client, isLoading: isLoadingClient } = useAllClientsQuery(!!clientId, (clients) =>
    clients.find((client) => client.centralClientId === clientId)
  );

  const tableData = useMemo(() => {
    return data?.map((item) => ({
      ...item,
      distribution: item.clientOverrides.length > 0 ? "Custom" : "Default",
    }));
  }, [data]);

  if (!client && !isLoadingClient) {
    history.push({
      pathname: `/abtesting`,
    });
  }

  function closeModal() {
    setModalOpen(false);
    setTimeout(() => {
      setSelectedFeature(null);
    }, 300);
  }

  return (
    <div className="page-container">
      <Breadcrumb customTitleSelector={(_, index) => (index > 1 && client ? client?.name : undefined)} />
      <h1 className="page-title">{client?.name} A/B Tests</h1>
      <SortableTable
        columns={columns}
        tableData={tableData as any}
        rowComponent={ABTestingFeatureTableCell}
        loading={isLoading}
        hideSearch={false}
        defaultSortIndex={0}
        setTableData={undefined}
        reverse={false}
        pagination={undefined}
        totalItemCount={data?.length}
        customRowProps={
          {
            onClick: (row: IFeatureDto) => {
              setSelectedFeature({ name: row.name, key: row.key ?? "" });
              setModalOpen(true);
            },
          } as any
        }
      />
      <Dialog open={modalOpen} onClose={closeModal} maxWidth="sm" fullWidth>
        <ABTestMetricsModal
          featureName={selectedFeature?.name ?? ""}
          featureKey={selectedFeature?.key ?? ""}
          closeModal={closeModal}
        />
      </Dialog>
    </div>
  );
}
